// ./utils/formatters.js

export const formatAsLocalDate = (dateInput) => {
  if (!dateInput) return "-";

  let date;

  if (dateInput instanceof Date) {
    date = dateInput;
  } else if (typeof dateInput === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
    // Treat plain "YYYY-MM-DD" as a local date, not UTC
    const [year, month, day] = dateInput.split("-").map(Number);
    date = new Date(year, month - 1, day);
  } else {
    // Fallback for full ISO with time, etc.
    date = new Date(dateInput);
  }

  if (Number.isNaN(date.getTime())) {
    console.error("Invalid date input:", dateInput);
    return "Invalid Date";
  }

  return date.toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
    day: "numeric",
  });
};

export function convertUTCToLocalTime(utcString) {
  const date = new Date(utcString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

// Must convert to UTC time before sending to server
export function convertTimeToUTC(localString) {
  if (!localString) return null;
  const [datePart, timePart] = localString.split(/[T ]/);
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = (timePart || "00:00:00")
    .split(":")
    .map(Number);

  const localDate = new Date(year, month - 1, day, hours, minutes, seconds);

  return localDate.toISOString();
}

// Must convert to UTC time before sending to server
export function convertDateToUTC(dateString) {
  if (!dateString) return null;
  const [year, month, day] = dateString.split("-").map(Number);

  // Use Date.UTC to construct UTC timestamps to avoid the impact of time zone offset
  const utcDate = new Date(Date.UTC(year, month - 1, day));

  // Extract UTC date and format it as yyyy-mm-dd
  return utcDate.toISOString().slice(0, 10);
}

export const formatCurrency = (value, currency = "USD") => {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
